function base64Encode(str) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';
    let utf8Str = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
        String.fromCharCode('0x' + p1)
    );

    let i = 0;
    while (i < utf8Str.length) {
        let c1 = utf8Str.charCodeAt(i++) & 0xff;
        if (i === utf8Str.length) {
            output += chars.charAt(c1 >> 2);
            output += chars.charAt((c1 & 0x3) << 4);
            output += '==';
            break;
        }
        let c2 = utf8Str.charCodeAt(i++);
        if (i === utf8Str.length) {
            output += chars.charAt(c1 >> 2);
            output += chars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            output += chars.charAt((c2 & 0xF) << 2);
            output += '=';
            break;
        }
        let c3 = utf8Str.charCodeAt(i++);
        output += chars.charAt(c1 >> 2);
        output += chars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        output += chars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
        output += chars.charAt(c3 & 0x3F);
    }

    return output;
}

function genLoginToken(userId) {
    const content = userId + '-' + Math.floor(Date.now() / 1000)
    const base64 = base64Encode(content)
    return 'UID' + base64 + 'PCK'
}

export default {
    genLoginToken
}


// WEBPACK FOOTER //
// ./src/utils/userTokenUtils.js